import { render, staticRenderFns } from "./GFActurialList.vue?vue&type=template&id=88ef6504"
import script from "./GFActurialList.vue?vue&type=script&lang=js"
export * from "./GFActurialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports